// Vendor imports
const classNames = require('classnames')
const PropTypes = require('prop-types')
// Shared imports
const BemEntity = require('shared/bem')
// Client V2 common imports
const tag = require('client-v2/common/utils/hyperscript')
// Entry container imports
const ProfileUserRecord = require('../../profile-user/record')

const bem = BemEntity('UserProfileFeedEmptyMessage')

function createEmptyMessage(template) {
  function EmptyMessage(props) {
    return tag('div', {
      className: classNames(
        props.className,
        bem.block()
      )
    },
      template(`@${props.profileUser.username}`)
    )
  }

  EmptyMessage.propTypes = {
    className: PropTypes.string,
    profileUser: PropTypes.shape(ProfileUserRecord.propTypes).isRequired
  }

  return EmptyMessage
}

const templates = {
  EmptyContentMessage: username => `${username} hasn’t posted any content yet.`,
  EmptyFollowersMessage: username => `No one is following ${username} yet.`,
  EmptyFollowingMessage: username => `${username} isn't following anyone yet.`,
  EmptySubscribedMessage: username => `${username} has not subscribed to any collections yet.`
}
Object.keys(templates).forEach(componentName => {
  exports[componentName] = createEmptyMessage(templates[componentName])
})
exports.EmptySelfPostsMessage = require('./empty-self-posts-message')
